import React, { useContext } from "react";
import FHeader from "../../components/header";
import CheckoutForm from "../../components/checkout-form";
import {
  PaymentContext,
  PaymentContextValue,
} from "../../contexts/Payment/payment.context";
import "./index.scss";

const DemoPage = () => {
  const generateRandomReference = () => {
    const length = 10;
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for (let i = 0; i < length; i++) {
      result += characters.charAt(
        Math.floor(Math.random() * characters.length)
      );
    }
    return result;
  };

  const payWithSarepay = (email, amount) => {
    if (!email) {
      console.error("Email is missing!");
      return;
    }
    const randomReference = generateRandomReference();
    localStorage.setItem("myReference", randomReference);
    window.Sarepay.initialize({
      key: process.env.REACT_APP_PUBLIC_KEY,
      token: process.env.REACT_APP_TOKEN,
      amount,
      currency: "NGN",
      feeBearer: "merchant",
      customer: { name: "Demo Customer", email },
      containerId: "payment-container",
      reference: randomReference,
      metadata: { tester: "Me" },
      onClose: function () {
        console.log("😩, you are gone");
      },
      onSuccess: function (data) {
        console.log(data);
      },
      onFailed: function (data) {
        console.log(data);
      },
    });
  };

  return (
    <div className="main-container patterned-background overflow-y-scroll">
      <main className="h-screen flex-col md:mx-[7rem] px-5">
        <div className="container mx-auto">
          <FHeader />
          <section className="sm:flex">
            <div className="md:w-1/2">
              <div className="text-white flex justify-center sm:justify-start mx-2 items-center sm:h-screen">
                <div className="text-center sm:text-left mt-6">
                  <div className="md:mt-6 md:mr-4">
                    <p className="font-bold text-2xl">Try Local APM Now</p>
                    <p className="lg:text-3xl text-xl mt-4 lg:mr-24">
                      Ready to collect payment with Local APM? Create an account
                      in less than 2 minutes
                    </p>
                  </div>
                  <div className="flex justify-center sm:justify-start items-center my-6">
                    <button
                      type="button"
                      className="text-white rounded-xl lg:w-64 py-3 px-2 font-semibold shadow-md hover:opacity-90 transition-all"
                      style={{
                        background:
                          "linear-gradient(135deg, var(--SarepayPrimary-color) 0%, var(--Checkout-accent-color) 100%)",
                      }}
                    >
                      Create a free account
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="sm:w-1/2 flex justify-center sm:justify-end items-center">
              <div className="bg-white rounded-2xl p-4 sm:p-8 border border-[#e4e7ec] shadow-xl shadow-[#6366f122]">
                <section className="md:max-w-[450px]">
                  <h2 className="text-center sm:text-4xl text-2xl font-bold mb-6 md:mt-12 mt-2">
                    Try Local APM Checkout
                  </h2>
                  <div className="mb-12">
                    <p className="text-sm text-center md:hidden">
                      To see how our checkout works, make a live payment with a
                      small amount.
                      <span className="font-bold"> Please note </span> that your
                      card will be <span className="font-bold">charged,</span>{" "}
                      and your account will be
                      <span className="font-bold"> debited</span> for this
                      transaction
                    </p>
                    <p className="hidden md:block text-center">
                      To see how our checkout works, make a live payment with a
                      small amount.
                      <span className="font-bold">Please note </span> that your
                      card will be <span className="font-bold">charged,</span>{" "}
                      and your account will be
                      <span className="font-bold"> debited</span> for this
                      transaction
                    </p>
                  </div>
                </section>
                <CheckoutForm payWithSarepay={payWithSarepay} />
              </div>
            </div>
          </section>
        </div>
      </main>
    </div>
  );
};

export default DemoPage;
